module.exports = __webpack_public_path__ + "static/media/white-castle-placuta.af28d8dd.png";